module.exports = __webpack_public_path__ + "img/feature_3.e1287dc7.png";